import { Joint, KinematicData } from '@/models/reportV2.model';

import { getAllStridesKinematicData, getMeanKinematicData } from '.';

/**
 * Retrieves all kinematic data for a specific joint.
 *
 * @param data - The input data.
 * @param joint - The joint to retrieve kinematic data for.
 * @returns The kinematic data object containing all strides and the mean.
 */
export function getAllKinematicData(data: any, joint: Joint): KinematicData {
  const allStrides = getAllStridesKinematicData(data, joint);
  const mean = getMeanKinematicData(data, joint);

  const KinematicData = {
    allStrides,
    mean,
  };
  return KinematicData;
}
